import { Tooltip as TippyTooltip } from 'react-tippy'
import 'react-tippy/dist/tippy.css'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid ${props => props.theme.colors.secondaryLight};
`

export const Header = styled.span`
  display: inline-block;
  margin-right: 30px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  line-height: 20px;
  color: #222;
`

const Icon = styled.a`
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: ${props => (props.isSelected ? '2px' : '6px')} solid #fff;
  margin-right: 10px;
  box-sizing: border-box;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
  cursor: pointer;
`

export const IconAll = styled(Icon)`
  background: ${props => props.theme.colors.icons.iconAll};
`

export const IconGood = styled(Icon)`
  background: ${props => props.theme.colors.icons.iconGood};
`

export const IconMaybe = styled(Icon)`
  background: ${props => props.theme.colors.icons.iconMaybe};
`

export const IconBad = styled(Icon)`
  background: ${props => props.theme.colors.icons.iconBad};
`

export const Tooltip = styled(TippyTooltip)``



// WEBPACK FOOTER //
// ./src/components/PhotosFiltering/theme.js